import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { GuardUtilsService } from '../services/guard-utils.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class DemoModeGuard {
  private userService = inject(UserService);
  private guardUtilsService = inject(GuardUtilsService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.userService.getUser();

    if (user.demo_mode) {
      this.guardUtilsService.handleNoAccess(
        'Module not available',
        'This module is not available in demo mode. Please complete onboarding to get access to all modules.',
      );
      return false;
    }

    return true;
  }
}
